<template>
  <div class="cotainer" id="cotainer">
    <a-modal
      class="gufiiguy"
      title="新增项目"
      :visible="addProjectVisible"
      @cancel="closeAddPost"
      width="70%"
      @ok="addPost"
    >
      <div class="containerBody">
        <a-table
          :data-source="addProjectList"
          bordered
          :loading="loading"
          :pagination="false"
          :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        >
          <a-table-column key="index" title="序号" ellipsis="true" data-index="index" width="100px">
            <template scope="text, record, index">
              {{ index + 1 }}
            </template>
          </a-table-column>
          <a-table-column key="factorName" title="检测项目名称" ellipsis="true" data-index="factorName" />
          <a-table-column key="price" title="单价(元)" ellipsis="true" data-index="price" />
        </a-table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { itemAddBatch } from '@/api/surrounding'
export default {
  props: ['addProjectVisible', 'addProjectList', 'ids'],
  data() {
    return {
      selectedRowKeys: '',
      selectList: [],
      projectList: [],
      scroll_y: 150,
    }
  },
  mounted() {
    var max_h = $('#cotainer').height()
    console.log(max_h, 'max_h======================')
    this.scroll_y = max_h - 40
  },
  methods: {
    // 弹窗关闭事件
    closeAddPost() {
      this.addProjectVisible = false
      this.$emit('changeProjectVisible', this.addProjectVisible)
    },
    // 弹窗提交事件
    addPost() {
      console.log(this.ids, 'this.ids===============================')
      console.log(this.selectList, 'this.selectListthis.selectList2222222222222')
      if (this.selectList.length != 0) {
        var id = []
        this.selectList.forEach((item) => {
          id.push(item.id)
        })
        itemAddBatch({
          pollutantIdList: id,
          quoteTestItem: this.ids,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            // this.projectList = res.data
            // 刷新项目列表
            this.$emit('reshProjectList')
            this.addProjectVisible = false
            this.selectedRowKeys = ''
            this.selectList = []
            this.$emit('changeProjectVisible', this.addProjectVisible)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.warning('请选择要添加的项目!')
      }
    },
    // 多选
    onSelectChange(selectedRowKeys, val) {
      console.log(selectedRowKeys, val, 'valvalvalvalvalvalvalvalval')
      this.selectedRowKeys = selectedRowKeys
      this.selectList = val
    },
  },
}
</script>

<style>
.containerBody {
  padding: 20px;
  margin: 20px;
}
.cotainer {
  height: 100%;
}
</style>